import React, { useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { routes } from '../../routes/routes-names';
import { linkedInSignOut, signOut } from '../../../redux/user';
import AuthModal from '../../registration';
import websitelogo from '../../../assets/img/offerx-logo.svg';
import { authType } from '../../../lib/auth-type';
import { SuspendEnum } from '../../../types/suspension';
import { sessionStorageClearAll } from '../../../components/storage/sessionStorageManager';
import useUser, { useHRMSUser } from '../../../hooks/useSelector';
import {
    localStorageGetItem,
    localStorageRemoveItem,
    localStorageSetItem,
} from '../../../components/storage/localStorageManager';
import { signHRMSOut } from '../../../redux/hrms';
import { useAppDispatch } from '../../../redux/reduxhooks';
import SignupLayout from '../../../components/registration/SignupLayout';
import { RegistrationProvider, useRegistration } from '../../../components/registration/RegistrationContext';
import { isIntegrationsEnabled } from '../../../config/constants';

type Props = {
    candidateId?: string;
    managerId?: string;
};

const MainHeader: React.FC<Props> = ({ candidateId, managerId }) => {
    const dispatch = useAppDispatch();
    const hasUser = useUser();
    const hasHRMSUser = useHRMSUser();
    const socialAuthType = authType.getAuthType();

    const navigate = useNavigate();

    const integrationsEnabled = String(isIntegrationsEnabled).toLowerCase() === 'true' ? true : false;

    const { resetAllState } = useRegistration();

    const recentSearchId = localStorageGetItem('recentSearch-id', false);

    const removeUnclaimedSearchResults = () => {
        if (recentSearchId) {
            const recentSearchData = localStorageGetItem(`recentSearch-${recentSearchId}`, false);

            if (recentSearchData) {
                const result = recentSearchData.filter((value: any) => value.isUser !== 1);
                localStorageSetItem(`recentSearch-${recentSearchId}`, result, false);
            }
        }
    };

    return (
        <>
            <header className="landing-page">
                <nav className="navbar navbar-expand-lg navbar-toggleable-sm navbar-light py-0">
                    <div className="container">
                        <Link to={routes.main} className="navbar-brand py-0 fs-28 fw-700" onClick={resetAllState}>
                            <img src={websitelogo} className="site-logo" fetchPriority="high" alt="OfferX Logo" />
                        </Link>
                        <button
                            className="navbar-toggler border-0"
                            type="button"
                            data-bs-target="#offcanvasNavbar"
                            data-bs-toggle="offcanvas"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon" />
                        </button>
                        <div
                            // aria-hidden="true"
                            // aria-labelledby="offcanvasNavbarLabel"
                            className="flex-sm-row-reverse offcanvas offcanvas-end"
                            id="offcanvasNavbar"
                            data-bs-scroll="true"
                            // tabIndex={0}
                        >
                            <div className="offcanvas-header ml-auto">
                                <button
                                    data-sider-close
                                    aria-label="Close"
                                    className="btn-close text-reset ms-auto"
                                    data-bs-dismiss="offcanvas"
                                    type="button"
                                />
                            </div>
                            <div className="offcanvas-body mobile-offcanvas">
                                <ul className="navbar-nav flex-grow">
                                    <li className="nav-item">
                                        <NavLink
                                            to={routes.main}
                                            className={({ isActive }) =>
                                                isActive ? 'nav-link text-dark active' : 'nav-link text-dark'
                                            }
                                            // tabIndex={0}
                                            title="Home"
                                        >
                                            Home
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink
                                            to={routes.about}
                                            className={({ isActive }) =>
                                                isActive ? 'nav-link text-dark active' : 'nav-link text-dark'
                                            }
                                            // tabIndex={0}
                                            title="About Us"
                                        >
                                            About Us
                                        </NavLink>
                                    </li>
                                    <li className="nav-item" tabIndex={0}>
                                        <div className="collapse navbar-collapse" id="navbarNavDarkDropdown">
                                            <ul className="navbar-nav cursor-pointer">
                                                <li className="nav-item dropdown">
                                                    <div
                                                        className="nav-link text-dark pe-0"
                                                        data-bs-toggle="dropdown"
                                                        // aria-expanded="false"
                                                        tabIndex={0}
                                                    >
                                                        Resources <i className="bi bi-chevron-down"></i>
                                                    </div>
                                                    <ul className="dropdown-menu resources-dropdown ms-lg-3 ms-0">
                                                        <li>
                                                            <NavLink
                                                                to={routes.podCast}
                                                                className={({ isActive }) =>
                                                                    isActive
                                                                        ? 'dropdown-item fs-14 active'
                                                                        : 'dropdown-item fs-14'
                                                                }
                                                                title="Podcast"
                                                                // tabIndex={0}
                                                            >
                                                                Podcast
                                                            </NavLink>
                                                        </li>
                                                        <li>
                                                            <NavLink
                                                                to={routes.webinars}
                                                                className={({ isActive }) =>
                                                                    isActive
                                                                        ? 'dropdown-item fs-14 active'
                                                                        : 'dropdown-item fs-14'
                                                                }
                                                                title="Webinars"
                                                                // tabIndex={0}
                                                            >
                                                                Webinars
                                                            </NavLink>
                                                        </li>
                                                        <li>
                                                            <NavLink
                                                                to={routes.successStories}
                                                                className={({ isActive }) =>
                                                                    isActive
                                                                        ? 'dropdown-item fs-14 active'
                                                                        : 'dropdown-item fs-14'
                                                                }
                                                                title="Success stories"
                                                                // tabIndex={0}
                                                            >
                                                                Success Stories
                                                            </NavLink>
                                                        </li>
                                                        {/* <li>
                                                            <NavLink
                                                                to={routes.octoberEvent}
                                                                className={({ isActive }) =>
                                                                    isActive
                                                                        ? 'dropdown-item fs-14 active'
                                                                        : 'dropdown-item fs-14'
                                                                }
                                                                title="Events"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                // tabIndex={0}
                                                            >
                                                                Events
                                                            </NavLink>
                                                        </li> */}
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li className="nav-item" tabIndex={0}>
                                        <div className="collapse navbar-collapse" id="navbarNavDarkDropdown">
                                            <ul className="navbar-nav cursor-pointer">
                                                <li className="nav-item dropdown">
                                                    <div
                                                        className="nav-link text-dark pe-0"
                                                        data-bs-toggle="dropdown"
                                                        // aria-expanded="false"
                                                        tabIndex={0}
                                                    >
                                                        Get Pricing <i className="bi bi-chevron-down"></i>
                                                    </div>
                                                    <ul className="dropdown-menu resources-dropdown ms-lg-3 ms-0">
                                                        <li>
                                                            <NavLink
                                                                to={routes.subscriptionPlans}
                                                                className={({ isActive }) =>
                                                                    isActive
                                                                        ? 'dropdown-item fs-14 active'
                                                                        : 'dropdown-item fs-14'
                                                                }
                                                                title="Subscription Plans"
                                                                // tabIndex={0}
                                                            >
                                                                Subscription Plans
                                                            </NavLink>
                                                        </li>
                                                        <li>
                                                            <NavLink
                                                                to={routes.earnFreeSubscription}
                                                                className={({ isActive }) =>
                                                                    isActive
                                                                        ? 'dropdown-item fs-14 active'
                                                                        : 'dropdown-item fs-14'
                                                                }
                                                                title="Earn Free Subscription"
                                                                // tabIndex={0}
                                                            >
                                                                Earn Free Subscription
                                                            </NavLink>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                    {integrationsEnabled && (
                                        <li className="nav-item">
                                            <NavLink
                                                to={routes.marketplaceIntegrations}
                                                className={({ isActive }) =>
                                                    isActive ? 'nav-link text-dark active' : 'nav-link text-dark'
                                                }
                                                title="Integrations"
                                            >
                                                Integrations
                                            </NavLink>
                                        </li>
                                    )}
                                    <li className="nav-item">
                                        <NavLink
                                            to={routes.contact}
                                            className={({ isActive }) =>
                                                isActive ? 'nav-link text-dark active' : 'nav-link text-dark'
                                            }
                                            // tabIndex={0}
                                            title="Request Demo"
                                        >
                                            Request Demo
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        {hasHRMSUser &&
                                        !hasUser &&
                                        localStorageGetItem('hrmsuserApiToBeRun') &&
                                        hasHRMSUser.suspendedStatus !== SuspendEnum.suspended ? (
                                            <div className="nav-link text-dark">
                                                <Link
                                                    to={routes.apiIntegrate}
                                                    className="text-dark text-decoration-none"
                                                    onClick={() => {
                                                        localStorageRemoveItem('seosearch');
                                                    }}
                                                >
                                                    {hasHRMSUser.firstName}
                                                </Link>
                                                {' / '}
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        removeUnclaimedSearchResults();
                                                        socialAuthType === 'linkedIn'
                                                            ? dispatch(linkedInSignOut())
                                                            : dispatch(signHRMSOut());

                                                        setTimeout(() => {
                                                            sessionStorageClearAll();
                                                        }, 300);
                                                    }}
                                                >
                                                    Sign Out
                                                </button>
                                            </div>
                                        ) : (
                                            !hasUser && (
                                                <NavLink
                                                    to={routes.hrms}
                                                    className={({ isActive }) =>
                                                        isActive ? 'nav-link text-dark active' : 'nav-link text-dark'
                                                    }
                                                    // tabIndex={0}
                                                    title="Integrate Now"
                                                    onClick={resetAllState}
                                                >
                                                    Integrate Now
                                                </NavLink>
                                            )
                                        )}
                                    </li>
                                    {/* <li className="nav-item">
                                        <NavLink
                                            to={routes.pricing}
                                            activeClassName="active"
                                            className="nav-link text-dark"
                                        >
                                            Pricing
                                        </NavLink>
                                    </li> */}

                                    {!localStorageGetItem('hrmsuserApiToBeRun') && (
                                        <li className="nav-item">
                                            {hasUser &&
                                            hasUser &&
                                            localStorageGetItem('userApiToBeRun') &&
                                            hasUser &&
                                            hasUser.suspendedStatus !== SuspendEnum.suspended ? (
                                                <div className="nav-link text-dark">
                                                    <Link
                                                        to={routes.pendingOffers}
                                                        className="text-dark text-decoration-none"
                                                        onClick={() => {
                                                            localStorageRemoveItem('seosearch');
                                                        }}
                                                    >
                                                        {hasUser && hasUser.firstName}
                                                    </Link>
                                                    {' / '}
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            removeUnclaimedSearchResults();
                                                            socialAuthType === 'linkedIn'
                                                                ? dispatch(linkedInSignOut())
                                                                : dispatch(signOut(navigate));

                                                            setTimeout(() => {
                                                                sessionStorageClearAll();
                                                            }, 300);
                                                        }}
                                                    >
                                                        Sign Out
                                                    </button>
                                                </div>
                                            ) : (
                                                <Link
                                                    to={`${routes.signinSignup}`}
                                                    type="button"
                                                    className="btn signin-outline ms-lg-1 mb-lg-0 mb-3"
                                                    // tabIndex={0}
                                                    title="Sign In"
                                                    onClick={() => {
                                                        const close = document.querySelector(
                                                            '[data-sider-close]'
                                                        ) as HTMLButtonElement;
                                                        close.click();
                                                    }}
                                                >
                                                    Sign In
                                                </Link>
                                            )}
                                        </li>
                                    )}
                                    <li className="nav-item ms-lg-4 mb-0">
                                        <NavLink
                                            to={routes.signUp}
                                            className={({ isActive }) =>
                                                isActive
                                                    ? 'btn btn-primary register-btn active'
                                                    : 'btn btn-primary register-btn'
                                            }
                                            // tabIndex={0}
                                            title="Register"
                                            onClick={resetAllState}
                                        >
                                            Register
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

            <AuthModal candidateId={candidateId} managerId={managerId} />
            <RegistrationProvider candidateId={candidateId} managerId={managerId}>
                <SignupLayout candidateId={candidateId} managerId={managerId} />
            </RegistrationProvider>
            {/* <Hrms candidateId={candidateId} managerId={managerId} /> */}
        </>
    );
};

export default MainHeader;
